import moment from "moment"
import { t } from "../translates/translate"
import { apiOffset } from "./timezone"

/* Selected timezone offset for SQL CONVERT_TZ, e.g. "+05:00" (from cache, fallback to device) */
export const getTimezone = () => apiOffset()

/* Get id's array */
export const arrayID = (array) => {
    const newArray = []
    array.forEach((o) => {
        if (o.checked) {
            newArray.push(o.id)
        }
    })
    return newArray
}

/* Show notification */
export const notification = (text, icon = null, timer = 1500) => {

    return {
        html: `<p class="notification">${text}</p>`,
        icon,
        color: "white",
        background: "black",
        showConfirmButton: false,
        position: "top-right",
        timer,
        width: 400,
        backdrop: false,
        customClass: { icon: "notification-icon", htmlContainer: "notification-html", popup: "notification-popup" },
    }
}


/* Check Value */
export const checkValue = (value, defaultValue = "") => {

    if (value === null || value === undefined) {
        return defaultValue
    }

    return value
}

/* Check Boolean */
export const checkBoolean = (value) => {

    if (!value) {
        return false
    }

    return true
}

/* Get time */
export const getTime = (time) => {

    if (time) {

        const date = moment(time).format("YYYY-MM-DD")
        const today = moment(new Date()).format("YYYY-MM-DD")

        const yesterdayD = new Date()
        yesterdayD.setDate(yesterdayD.getDate() - 1)
        const yesterday = moment(yesterdayD).format("YYYY-MM-DD")

        let text = moment(date).format("Do MMM YYYY")

        if (moment(date).isSame(today, "day")) {
            text = t("time.today")
        }

        if (moment(date).isSame(yesterday, "day")) {
            text = t("time.yesterday")
        }

        return {
            time: moment(time).format("HH:mm"),
            date: text,
        }
    }

    return { time: "-", date: "-" }

}


/* Get Data */
export const permissionText = (value) => {

    const number = parseInt(value)

    if (Number.isInteger(number)) {

        if (number === 1) {
            return t("permission.one")
        }

        if (number > 1 && number <= 4) {
            return t("permission.few")
        }

        return t("permission.many")
    }

    return ""
}


/* Generate password */
export const generatePassword = () => {

    const length = 8
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!+_~@$%&*()"
    let password = ""

    for (let i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n))
    }

    return password
}


/* PRICE CONVERTOR */
export const convertor = (price, symbol = "", isAfter = 0, space = "\u0020") => {

    /* Check the price for the void */
    if (price === null || price === undefined)
        return "\u0020"

    const number = Number.parseFloat(price).toFixed(2)

    let before = ""
    let after = ""

    if (parseInt(isAfter) === 1) {
        after = "\u0020" + symbol
    }

    if (parseInt(isAfter) === 0) {
        before = symbol + "\u0020"
    }

    return before + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, space) + after
}




/* GET START AND END DATE  */
export const getDate = () => {

    const startDate = new Date()
    startDate.setHours(0)
    startDate.setMinutes(0)
    startDate.setSeconds(0)
    startDate.setDate(startDate.getDate() - 30)


    const endDate = new Date()
    endDate.setHours(23)
    endDate.setMinutes(59)
    endDate.setSeconds(59)

    return { startDate, endDate }
}


/* GET START AND END DATE  */
export const getToday = () => {

    const startDate = moment().format("YYYY-MM-DD 00:00:00")
    const endDate = moment().format("YYYY-MM-DD 23:59:59")

    return { startDate, endDate }
}



/* Get Avatar Of Player */
export const playerAva = (isTester = 0) => {

    if (parseInt(isTester) === 1) {
        return "/images/player/tester-ava.png"
    }

    const ava = ["/images/player/gamer.png", "/images/player/gamer2.png", "/images/player/gamer3.png", "/images/player/gamer4.png"]

    const random = Math.floor(Math.random() * ava.length)

    return ava[random]
}


/* Generate Ava */
export const ava = (number, type) => {

    /* VIP Ava */
    if (type === "test") {
        return "/images/player/tester-ava.png"
    }

    /* Fields */
    const images = [
        "/images/player/gamer1.png",
        "/images/player/gamer2.png",
        "/images/player/gamer3.png",
        "/images/player/gamer4.png",
        "/images/player/gamer5.png",
        "/images/player/gamer6.png",
        "/images/player/gamer7.png",
        "/images/player/gamer8.png",
        "/images/player/gamer9.png",
        "/images/player/gamer10.png",
        "/images/player/gamer11.png",
    ]

    if (images[number]) {
        return images[number]
    }

    let index = Math.floor(Math.random() * images.length)

    /* Check Number */
    if (number && parseInt(number) > -1) {
        index = number
    }

    return images[index]
}


export const converTime = (second) => {

    /* Check the second for the void */
    if (second === null || second === undefined)
        return "00:00:00"

    const number = parseInt(second, 10)
    let hours = Math.floor(number / 3600)
    let minutes = Math.floor((number - (hours * 3600)) / 60)
    let seconds = number - (hours * 3600) - (minutes * 60)

    if (hours < 10) {
        hours = "0" + hours 
    }
    if (minutes < 10) {
        minutes = "0" + minutes 
    }
    if (seconds < 10) {
        seconds = "0" + seconds 
    }

    return hours + ":" + minutes + ":" + seconds
}